import React from 'react';
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import CrumbRoute from 'components/CrumbRoute';
import {
  BO_CSV,
  BACK_OFFICE,
  BO_IMPORT,
  BO_TOOLS,
  BO_NOTIFICATIONS,
  BO_SIGNED_DOCUMENTS,
  BO_ADVISORS,
  BO_INSTITUTIONS
} from 'routes';
import Csv from './Csv/Csv';
import Tools from './Tools/Tools';
import Notifications from './Notifications/Notifications';
import FinInstitutions from './FinInstitutions/FinInstitutions';
import BOSignedDocuments from './SignedDocuments/BOSignedDocuments';
import Advisors from './Advisors/Advisors';
import { Tab } from '@material-ui/core';
import Tabs from 'components/CustomTabs/CustomTabs';
import Layout from 'components/Layout';
import Import from '../Admin/Import/Import';
import { ADMIN_IMPORT_PARTNERS, ADMIN_IMPORT_USERS } from '../../api/endpoints';

// FIXME: ???
const AdminTab = [BO_CSV] as const;

const BackOffice: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const handleTabChange = (_event: React.ChangeEvent<{}>, newTab?: typeof AdminTab[number]) => {
    newTab && history.push(newTab);
  };

  return (
    <Layout title={t('pageTitle_backoffice')} admin>
      <Tabs
        value={location.pathname === BACK_OFFICE ? BO_CSV : location.pathname}
        onChange={handleTabChange}
        fullWidth
      >
        <Tab value={BO_CSV} label={t('backOffice_csv_title')} />
        <Tab value={BO_IMPORT} label={t('admin_import_title')} />
        <Tab value={BO_INSTITUTIONS} label={t('backOffice_finInstitutions')} />
        <Tab value={BO_TOOLS} label={t('backOffice_tools')} />
        <Tab value={BO_NOTIFICATIONS} label={t('backOffice_notifications')} />
        <Tab value={BO_SIGNED_DOCUMENTS} label={t('general_documents')} />
        <Tab value={BO_ADVISORS} label={t('backOffice_advisors')} />
      </Tabs>

      <Switch>
        <Route exact path={BACK_OFFICE} render={() => <Redirect to={BO_CSV} />} />
        <CrumbRoute exact path={BO_CSV} component={Csv} title={t('backOffice_csv_title')} />
        <CrumbRoute
          exact
          path={BO_INSTITUTIONS}
          component={FinInstitutions}
          title={t('backOffice_finInstitutions')}
        />
        <CrumbRoute
          exact
          path={BO_IMPORT}
          render={() => (
            <Import
              importMap={{
                users: {
                  heading: t('admin_uploads_users'),
                  endpoint: ADMIN_IMPORT_USERS,
                  entityText: t('admin_uploads_usersEnt'),
                  successText: t('admin_uploads_usersProcessed')
                },
                partners: {
                  heading: t('admin_uploads_partners'),
                  endpoint: ADMIN_IMPORT_PARTNERS,
                  entityText: t('admin_uploads_partnersEnt'),
                },
              }}
            />
          )}
          title={t('admin_import_title')}
        />
        <CrumbRoute
          exact
          path={BO_TOOLS}
          component={Tools}
          title={t('backOffice_tools')}
        />
        <CrumbRoute
          exact
          path={BO_NOTIFICATIONS}
          component={Notifications}
          title={t('backOffice_notifications')}
        />
        <CrumbRoute
          exact
          path={BO_SIGNED_DOCUMENTS}
          component={BOSignedDocuments}
          title={t('general_documents')}
        />
        <CrumbRoute
          exact
          path={BO_ADVISORS}
          component={Advisors}
          title={t('backOffice_advisors')}
        />
      </Switch>
    </Layout>
  );
};

export default BackOffice;
